import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import { Button } from "@tql/ui-components-react/tql/buttons";

type EditConfirmationCellProps<T> = GridCustomCellProps & {
	save: (dataItem: T) => void;
	cancel: (dataItem: T) => void;
};

export const EditConfirmationCell = <T,>({
	save,
	cancel,
	...gridProps
}: EditConfirmationCellProps<T>) => {
	// Guard against undefined dataItem
	if (!gridProps.dataItem) {
		return <td {...gridProps.tdProps}></td>;
	}

	return (
		<td {...gridProps.tdProps}>
			<div className={"edit-confirmation-cell"}>
				<div>
					<Button
						onClick={() => save(gridProps.dataItem as T)}
						variant={"primary"}
					>
						Save Edits
					</Button>
				</div>

				<div>
					<Button onClick={() => cancel(gridProps.dataItem as T)}>
						Cancel
					</Button>
				</div>
			</div>
		</td>
	);
};
